import { HttpService } from "../index";
import { Storage } from '@ionic/storage';

export class EntityService {

    protected cacheTime = 1000 * 60 * 30; // half hour

    constructor(        
        protected httpService: HttpService ,
        protected storage: Storage
    ) {}

    clearCachedEntities(entity) : Promise<void> {
        return new Promise<void> ((resolve, reject) => {
            this.storage.remove('list-select-' + entity)
                .then(() => {
                    resolve();
                }).catch(() => {
                    resolve();
                });
        });
    }

    getCachedEntities(entity) : Promise<any> {
        return new Promise<any> ((resolve, reject) => {
            this.storage.get('list-select-' + entity)
                .then(data => {
                    if (data && (data.timestamp > ((new Date()).getTime()))) {
                        resolve(data.entities);
                    } else {
                        reject();
                    }
                });
        });
    }

    listSelectEntities(entity) : Promise<any> {
        return new Promise<any> ((resolve, reject) => {
            this.getCachedEntities(entity)
                .then((entities) => {
                    resolve(entities);
                }).catch(() => {
                    this.httpService.get('/api/v1/select/'+entity)
                        .then((response) => {
                            let entities = response.json();

                            this.storage.set('list-select-' + entity, {
                                timestamp : ( (new Date()).getTime() + this.cacheTime ) ,
                                entities  : entities
                            }).then(() => {
                                resolve(response.json());
                            });                            
                        }).catch((error) => {
                            reject(error);
                        });
                });            
        });
    }

    listEntities(entity:string, params:any = null) : Promise<any> {
        return new Promise<any> ((resolve, reject) => {
            this.httpService.get(this.path(entity), params).then((response) => {
                resolve(response.json());
            }).catch((error) => {
                reject(error);
            });
        });
    }

    createEntity(entity, data) : Promise<any> {
        return new Promise<any> ((resolve, reject) => {
            this.httpService.post(this.path(entity), data)
                .then(response => {
                    resolve(response.json());
                }).catch(error => {
                    reject(error);
                });
        });
    }

    editEntity(entity, id, data) : Promise<any> {
        return new Promise<any> ((resolve, reject) => {
            this.httpService.put(this.path(entity, id), data)
                .then(response => {
                    resolve(response.json());
                }).catch(error => {
                    reject(error);
                });
        });
    }

    readEntity(entity:string, id:string, params:any = null) : Promise<any> {
        return new Promise<any> ((resolve, reject) => {
            this.httpService.get(this.path(entity,id), params)
                .then(response => {
                    resolve(response.json());
                }).catch(error => {
                    reject(error);
                });
        });        
    }

    removeEntity(entity:string, id:string) : Promise<any> {
        return new Promise<any> ((resolve, reject) => {
            this.httpService.delete(this.path(entity,id))
                .then(response => {
                    resolve();
                }).catch(error => {
                    reject(error);
                });
        });
    }

    path(entity:string, id:string = null) : string {
        return '/api/v1/' + entity + (id ? ('/' + id) : '');
    }

}


// WEBPACK FOOTER //
// ./src/services/entity/entity-service.ts